import React from 'react';
import { Select } from 'antd';
import './index.scss';
import { CLSTAG } from '@/utils/constant';
import { clstagStr } from '@/utils/util';
const { Option } = Select;
type Iprop = {
  label: string;
  className?: string;
  onChange: AnyFunc;
  options: {
    label: string;
    value: string | number;
    count: number;
  }[];
  clstag?: CLSTAG;
};
const SelectComp = (props: Iprop) => {
  const { label, options, className, onChange, clstag } = props;
  return (
    <div
      className={`select-wrapper ${className || ''}`}
      clstag={clstag && clstagStr(clstag)}
    >
      <span>{label}</span>
      <Select onChange={onChange} defaultValue={''}>
        {options.map((item: any, index) => (
          <Option value={item.value} key={item.value}>
            <span>{item.label}</span>
            <span>({item.count})</span>
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default React.memo(SelectComp);
